export default __webpack_public_path__ + "static/media/imagem_login.beb6730e.png";